export const typeStyles = {
  empty: {
    bg: "bg-white",
    border: "border-gray-500",
    tag: {
      label: "EMPTY",
      icon: null,
      tagBg: "bg-gray-500",
      tagText: "text-white",
    },
  },
  open: {
    bg: "bg-white",
    border: "border-pink-400",
    tag: {
      label: "OPEN",
      tagBg: "bg-pink-600",
      tagText: "text-white",
    },
  },
  open_claim: {
    bg: "bg-white",
    border: "border-pink-400",
    tag: {
      label: "OPEN",
      icon: <i className="fa fa-user-check text-xxs mr-1" />,
      tagBg: "bg-pink-600",
      tagText: "text-white",
    },
  },
  shift_offer: {
    bg: "g-white",
    border: "border-green-500",
    text: "text-gray-900",
    tag: {
      label: "OFFER",
      icon: <i className="fa fa-solid fa-hand-holding-heart text-xxs mr-1" />,
      tagBg: "bg-orange-600",
      tagText: "text-white",
    },
  },
  shift_swap: {
    bg: "g-white",
    border: "border-green-500",
    text: "text-gray-900",
    tag: {
      label: "SWAP",
      icon: <i className="fa fa-solid fa-shuffle text-xxs mr-1" />,
      tagBg: "bg-pink-600",
      tagText: "text-white",
    },
  },
  default: {
    bg: "bg-white",
    border: "border-green-500",
    text: "text-gray-900",
    tag: null,
  },

  leave: {
    bg: "bg-white",
    border: "border-yellow-400",
    tag: {
      label: "LEAVE",
      tagBg: "bg-yellow-600",
      tagText: "text-white",
    },
  },

  unavailable: {
    bg: "bg-white",
    border: "border-red-400",
    tag: {
      label: "UNAVAILABLE",
      tagBg: "bg-red-600",
      tagText: "text-white",
    },
  },
};

export const statusStyles = {
  started: {
    tag: {
      label: "STARTED",
      icon: null,
      tagBg: "bg-rose-500",
      tagText: "text-white",
    },
  },
  pending: {
    tag: {
      label: "PENDING",
      icon: null,
      tagBg: "bg-yellow-500",
      tagText: "text-white",
    },
  },
  approved: {
    tag: {
      label: "APPROVED",
      icon: <i className="fa fa-circle-check text-xxs mr-1" />,
      tagBg: "bg-green-600",
      tagText: "text-white",
    },
  },
  rejected: {
    tag: {
      label: "REJECTED",
      icon: <i className="fa-regular fa-circle-xmark text-xxs mr-1" />,
      tagBg: "bg-pink-600",
      tagText: "text-white",
    },
  },
  missed: {
    tag: {
      label: "MISSED",
      tagBg: "bg-blue-600",
      tagText: "text-white",
    },
  },
  default: {
    tag: {
      label: "",
      tagBg: "bg-white",
      tagText: "text-white",
    },
  },
};

export const accessMap = {
  employee: "Employee",
  company_manager: "Company Manager",
  system_administrator: "System Administrator",
};

export const employmentTypes = {
  casual: "Casual",
  part_time: "Part Time",
  full_time: "Full Time",
  contractor: "Contractor",
};

export const stressProfileMap = {
  "2_days_per_week": "2 days per week",
  "24_7": "24/7",
  overtime_40: "CA Overtime 40hrs/week",
  max_20_hours: "Max 20 hours/week",
  normal_38_hours_per_week: "Normal 38 hours/week",
  standard_40: "Standard 40 hours",
};
